import { useSetState, useDeepCompareEffect } from 'ahooks'
import { Form } from 'antd-mobile'
import dayjs from 'dayjs'
import React from 'react'

import NewEditForm from '@/components/NewEditForm'
import { certificateFromData } from '@/components/NewEditForm/UILibrary/HYBElement/BlockLevel/BlockLevelForm/utils'
import { useCommonForm } from '@/hooks'
import { isNumber, checkMonthsDifference } from '@/utils/index'

import HPopup from '../../HYBVant/HPopup'
import './index.less'

const HealthCertificate: React.FC<any> = ({ visible, onCancel, modalData }) => {
  const {
    staff_Id,
    runDeleteHrmRewardPunishment,
    runSaveRewardPunishment,
    deleteHrmRewardPunishmentLoading,
    saveRewardPunishmentLoading,
    status,
    editItem
  } = modalData
  const [formIt] = Form.useForm()
  const [{ randomForm }, setState] = useSetState<any>({
    randomForm: null
  })
  console.log('status----editItem', status, editItem)
  const onFinish = (fieldValues: any) => {
    if (deleteHrmRewardPunishmentLoading || saveRewardPunishmentLoading) return
    const attachments = certificateFromData(fieldValues?.attachments || [])
    const start_date = fieldValues?.start_date
      ? dayjs(fieldValues?.start_date).format('YYYY-MM-DD')
      : null
    const end_date =
      isNumber(fieldValues?.end_date) && fieldValues?.start_date
        ? dayjs(fieldValues?.start_date)?.add(fieldValues?.end_date, 'months').format('YYYY-MM-DD')
        : null
    const values_info = {
      ...fieldValues,
      attachments,
      id: editItem?.id || null,
      employee_ids: staff_Id ? [staff_Id] : null,
      start_date,
      end_date
    }
    runSaveRewardPunishment(values_info)
  }

  useDeepCompareEffect(() => {
    const setFieldValues = (bool: boolean) => {
      const created_at = editItem?.created_at ? editItem?.created_at : dayjs().format('YYYY-MM-DD')
      const rowInfo = {
        ...editItem,
        created_at,
        start_date: editItem?.start_date
          ? dayjs(editItem?.start_date, 'YYYY-MM-DD').format('YYYY-MM-DD')
          : null,
        end_date: checkMonthsDifference(editItem?.start_date, editItem?.end_date)
      }
      formIt.setFieldsValue(rowInfo)

      setState({ randomForm: Math.random() })
    }
    setFieldValues(status === 'Edit')
  }, [status, editItem])
  const deleteInfo = () => {
    if (status === 'Edit') {
      const fields = editItem
      const id = fields?.id
      const ids = id ? [id] : null
      runDeleteHrmRewardPunishment({ id: ids })
    }
  }
  const getFormButtons = (hasDelete?: boolean) => {
    const btns = [
      {
        key: 'remove',
        title: '删除',
        className: 'delete-btn',
        onClick: deleteInfo
      },
      {
        key: 'submit',
        title: '保存'
      }
    ]
    return hasDelete ? btns : btns.slice(1)
  }

  const { option, optionStatus } = useCommonForm({
    code: 'reward_punishment_from',
    vars: {},
    immediate: true
  })
  console.log('optionStatus', optionStatus)
  return (
    <HPopup
      title='奖惩记录'
      hasOk={false}
      className='lg'
      visible={visible}
      onCancel={onCancel}
      destroyOnClose
    >
      {optionStatus === 'DONE' && (
        <div className='income-tax-declaration-popup'>
          <NewEditForm
            formInst={formIt}
            formInfo={option?.formInfo ?? []}
            onFinish={onFinish}
            randomForm={randomForm}
            formButtons={getFormButtons(modalData?.status === 'Edit')}
          />
        </div>
      )}
    </HPopup>
  )
}

export default HealthCertificate
